import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "../elements/logo";
import {
  contactLocation,
  cookieLocation,
  privacyLocation,
  siteMapLocation,
  tableBooker,
} from "../../constants/routing";
import { RESTAURANT_ADDRESS, RESTAURANT_EMAIL, RESTAURANT_PHONE, RESTAURANT_PHONE_HREF } from "../../constants/contact";
import { Button } from "../ui/button";
import { siteNavItems } from "./site-nav";

export function Footer() {
  return (
    <footer className="border-t border-border/60 bg-[#f7f2ea]">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-[1.1fr_0.7fr_0.9fr]">
          <div>
            <Logo variant="dark" className="h-10 w-auto" />
            <h3 className="mt-4 max-w-md font-display text-4xl text-[#173530]">
              Italiaans restaurant in het centrum van Genk.
            </h3>
            <div className="mt-6 space-y-4 text-sm text-[#5b5d54]">
              <div className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 text-accent" />
                <span>{RESTAURANT_ADDRESS}</span>
              </div>
              <div className="flex items-start gap-3">
                <Phone className="mt-0.5 h-4 w-4 text-accent" />
                <a href={RESTAURANT_PHONE_HREF} className="transition-colors hover:text-[#173530]">
                  {RESTAURANT_PHONE}
                </a>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="mt-0.5 h-4 w-4 text-accent" />
                <a href={`mailto:${RESTAURANT_EMAIL}`} className="transition-colors hover:text-[#173530]">
                  {RESTAURANT_EMAIL}
                </a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-display text-2xl text-[#173530]">Navigatie</h3>
            <nav className="mt-5 grid gap-3 text-sm text-[#5b5d54]">
              {siteNavItems.map((item) => (
                <Link key={item.to} to={item.to} className="transition-colors hover:text-[#173530]">
                  {item.label}
                </Link>
              ))}
              <Link to={privacyLocation} className="transition-colors hover:text-[#173530]">
                Privacybeleid
              </Link>
              <Link to={cookieLocation} className="transition-colors hover:text-[#173530]">
                Cookies
              </Link>
              <Link to={siteMapLocation} className="transition-colors hover:text-[#173530]">
                Sitemap
              </Link>
            </nav>
          </div>

          <div className="rounded-3xl border border-border bg-white p-6 shadow-sm border border-[#e7dfd2]">
            <p className="text-xs uppercase tracking-[0.3em] text-[#5b5d54]">Plan uw bezoek</p>
            <h3 className="mt-3 font-display text-3xl text-[#173530]">Reserveer rechtstreeks online.</h3>
            <p className="mt-3 text-sm leading-6 text-[#5b5d54]">
              Voor grote tafels of speciale vragen helpen we graag verder via de contactpagina.
            </p>
            <div className="mt-6 grid gap-3">
              <Button asChild className="bg-accent text-[#1f1a12] hover:bg-accent-dark">
                <a href={tableBooker} target="_blank" rel="noreferrer">
                  Online reserveren
                </a>
              </Button>
              <Button asChild variant="outline">
                <Link to={contactLocation}>Neem contact op</Link>
              </Button>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-border/80 pt-6">
          <p className="text-center text-xs text-[#5b5d54]">
            © {new Date().getFullYear()} La Piazza Genk. Alle rechten voorbehouden.
          </p>
        </div>
      </div>
    </footer>
  );
}
